var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.isGeneric ? _c('div', {
    staticClass: "json_payload_view"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.val,
      expression: "val"
    }],
    attrs: {
      "cols": "30",
      "row": "200",
      "disabled": ""
    },
    domProps: {
      "value": _vm.val
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.val = $event.target.value;
      }
    }
  })]) : _c('GenericPayloadView', {
    attrs: {
      "payload": _vm.payload
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }